import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  BehaviorSubject,
  catchError,
  filter,
  map,
  of,
  Subject,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TuiButtonModule, TuiDialogService } from '@taiga-ui/core';

import { AsyncPipe } from '@angular/common';

import { AlertService } from '@shared/services/alert.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ControlPanelComponent } from '@shared/components/control/control-panel/control-panel.component';

import { TUI_PROMPT } from '@taiga-ui/kit';
import { ControlRecord } from '../../../../types/control';

import { CargoLoadingState } from '../../store/cargo-loading.state';
import { CargoLoadingService } from '../../services/cargo-loading.service';

@Component({
  selector: 'app-control',
  imports: [
    AsyncPipe,
    ReactiveFormsModule,
    ControlPanelComponent,
    TuiButtonModule,
  ],
  templateUrl: './control.component.html',
  styleUrl: './control.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ControlComponent implements OnInit {
  @ViewChild('panel') panel: ControlPanelComponent;
  control$ = new Subject<void>();
  declaration$ = this.store.select(CargoLoadingState.getSelectedCargo);
  showRecalculateButton$ = new BehaviorSubject(false);
  records$ = new BehaviorSubject<ControlRecord[]>([]);

  constructor(
    private readonly store: Store,
    private readonly cargoLoadingService: CargoLoadingService,
    private readonly destroyRef: DestroyRef,
    private readonly alert: AlertService,
    private readonly dialogs: TuiDialogService,
  ) {}

  onRefresh() {
    this.control$.next();
  }

  showConfirmDialog(title: string) {
    return this.dialogs.open<boolean>(TUI_PROMPT, {
      data: {
        content: `<h1 class="font-bold text-lg">${title}<h1>`,
        yes: 'Подтвердить',
        no: 'Отмена',
      },
    });
  }

  getWareSortIndexesFromError(record: ControlRecord) {
    const uniqueIndexes = new Set<number>();
    record.items?.forEach(item => {
      const idx = Object.values(item);
      idx.forEach(index => uniqueIndexes.add(index));
    });
    return uniqueIndexes;
  }

  // getWareIdsBySortIndexes(wares: DtImportWareItem[], indexes: Set<number>) {
  //   const ids: number[] = [];
  //   wares.forEach(ware => {
  //     if (indexes.has(ware.sortIndex)) {
  //       ids.push(ware.id);
  //     }
  //   });
  //   return ids;
  // }

  ngOnInit() {
    this.control$
      .pipe(
        withLatestFrom(this.declaration$),
        map(([, declaration]) => declaration?.id),
        filter((id): id is number => Boolean(id)),
        switchMap(id =>
          this.cargoLoadingService.validate(id).pipe(
            catchError(() => {
              this.alert.showError('Ошибка проведения контроля');
              return of([]);
            }),
          ),
        ),
        tap(records => this.records$.next(records)),
        tap(() => {
          this.showRecalculateButton$.next(false);
          this.panel.openPanel();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
